$(document).ready(function () {
  //timeclock
  $(function () {
    $('#clock').showTimer({ returnType: "box", wrapper_id: "timewrapper" });
  });

  $(function () {
    $('#gift-clock').showTimer({ returnType: "box", wrapper_id: "gift-timewrapper" });
  });

  //reviews
  $('.reviews-slider').slick({
    //centerMode: true,
    //centerPadding: '60px',
    slidesToShow: 5,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 1000,
    dots: true,
    responsive: [
      {
        breakpoint: 1139,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 767,
        settings: {
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1
        }
      }
    ]
  });
  $('.socks-catalog-slider').slick({
    centerMode: true,
    centerPadding: '120px',
    slidesToShow: 4,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1139,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          centerPadding: '80px',
          slidesToShow: 1
        }
      }
    ]
  });

  $('a.button').on('click',function(){
    let target = $(this).attr('href')
    $('html, body').animate({
      scrollTop: $(target).offset().top
  }, 2000);
  });

  var initGridAddToCart = function(){
    $('.quick-addtocart').on('submit', function(e){
      e.preventDefault();
      var variant_id = $(this).find('input[name="id"]').val();

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          id: variant_id,
          quantity: 1
        },
        dataType: 'json',
        async: false,
        success: function(data) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: {
              product: data
            }
          }));
        }
      });
    });
  };

  initGridAddToCart();

  $(document).on('collectionFilter:complete', function(){
    initGridAddToCart();
  });

});